module.exports = __webpack_public_path__ + "assets/img/block-right-hover-c57c31e1.png";